// extracted by mini-css-extract-plugin
export default {"overrides":"media-alpha-module__overrides--R3w","secondary-ctas":"media-alpha-module__secondary-ctas--IvZ","secondaryCtas":"media-alpha-module__secondary-ctas--IvZ"};